export default __webpack_public_path__ + "static/jcb-f5372bf9f9e2363742f82229c2463051.jpg";